import { OrgId } from "@hex/common";
import React from "react";
import { z } from "zod";

import { useListenToBroadcastChannel } from "../hooks/useListenToBroadcastChannnel";
import {
  onLoginCallback,
  useLoginEventListener,
} from "../hooks/useLoginEventListener.js";
import { getUrlOrg } from "../orgs";

import { useQueryParams } from "./routes";

export const LoginEvent = z.object({
  source: z.literal("login"),
  // eslint-disable-next-line tree-shaking/no-side-effects-in-initialization -- building a schema is pure; the rule cannot see through a chained builder
  orgId: OrgId.optional(),
});
export type LoginEvent = z.infer<typeof LoginEvent>;

export const LoginListener: React.ComponentType = React.memo(
  function LoginListener() {
    const queryParams = useQueryParams();
    const urlOrgId = getUrlOrg();

    const onLogin = onLoginCallback(queryParams, urlOrgId);
    useListenToBroadcastChannel("login", onLogin);

    useLoginEventListener();

    return null;
  },
);
